// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_f6-6";
export var emphasizeQuantity = "_f6-3";
export var flatBottomCorners = "_f6-5";
export var productImage = "_f6-0";
export var quantityContainer = "_f6-2";
export var tooltip = "_f6-1";
export var wrapAndEllipsesOverflow = "_f6-4";